const SUPPORT_EMAIL = 'ONRC@company-x.co.nz';
const SUPPORT_PHONE = '0800 667276';

export {
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
};
